import { gql } from "@apollo/client";

const SAVE_CONCLUSION_VIRTUAL = gql`
    mutation saveVisitaConclusionVirtual($input: AddVisitaConclusionVirtualInput!){
        saveVisitaConclusionVirtual(input: $input) {
            idVisita
        }
    }
`;

export default SAVE_CONCLUSION_VIRTUAL;

export const adaptAddVisitaConclusionVirtualInput = (data, finalizada, latitud, longitud) => ({
    idVisita: data.idVisita,
    evolucion: data.evolucion,
    codigoAtencion: data.codigoAtencion,
    fechaFin: data.fechaFin,
    idComboVisitaValorInterlocutor: data.idComboVisitaValorInterlocutor,
    nombreCompleto: data.nombreCompleto,
    dNI: data.dNI,
    email: data.email,
    finalizada: !!finalizada,
    latitud: latitud?.toString(),
    longitud: longitud?.toString(),
    desdeCoordinacion : !!data?.desdeCoordinacion
});